import ResultField from "@/components/Calculator/Components/ResultField/resultField.component";
import ResultTitle from "@/components/Calculator/Components/ResultTitle/resultTitle.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { isValidPositiveNumber } from "@/utils/calculators";

type Props = {
    wallArea: number;
    brickArea: number;
    brickWidth: number;
    mailParams: Record<string, string>;
};

const Result = ({ wallArea, brickArea, brickWidth, mailParams }: Props) => {
    const { t } = useGranite();

    const nrOfBlocks = () => {
        const nrOfBlocks = Math.ceil(wallArea / brickArea);

        return isValidPositiveNumber(nrOfBlocks) ? nrOfBlocks : 0;
    };

    const amountOfKgGlue = () => {
        const adjustmentFactor = brickWidth / 3.85;
        const amountOfKgGlue = Number(wallArea * adjustmentFactor * 1.1);

        return isValidPositiveNumber(amountOfKgGlue) ? amountOfKgGlue : 0;
    };

    const nrOf25KgBagsGlue = () => {
        const nrOf25KgBagsGlue = Number(Math.ceil(amountOfKgGlue() / 25));

        return isValidPositiveNumber(nrOf25KgBagsGlue) ? nrOf25KgBagsGlue : 0;
    };

    const nrOfBlocks10PercentLoss = () => Number(Math.ceil(nrOfBlocks() * 1.1));

    return (
        <div className={"mt-4"}>
            <ResultTitle mailParams={mailParams} />
            <Row>
                <ResultField
                    copy={t("calculator.ytongCalculator.wallArea")}
                    value={wallArea.toFixed(2)}
                    unit={"m"}
                    sup={2}
                    sm={6}
                    lg={3}
                />
                <ResultField
                    copy={t("calculator.ytongCalculator.ytongBlockArea")}
                    copyPostfix={t(
                        "calculator.ytongCalculator.includingJointCement3mm"
                    )}
                    value={brickArea.toFixed(2)}
                    unit={"m"}
                    sup={2}
                    sm={6}
                    lg={3}
                />
            </Row>
            <Row>
                <Col
                    md={12}
                    lg={6}
                >
                    <h4 className="d-sm-block">
                        {t("calculator.ytongCalculator.AmountOfBlocks")}
                    </h4>
                    <Row>
                        <ResultField
                            copy={t(
                                "calculator.ytongCalculator.AmountOfYtongBlocks"
                            )}
                            value={nrOfBlocks().toFixed(0)}
                            sm={6}
                        />
                        <ResultField
                            copy={t(
                                "calculator.ytongCalculator.AmountOfYtongBlocks"
                            )}
                            copyPostfix={t(
                                "calculator.ytongCalculator.10%Loss"
                            )}
                            value={nrOfBlocks10PercentLoss().toFixed(0)}
                            sm={6}
                        />
                    </Row>
                </Col>
                <Col
                    md={12}
                    lg={6}
                >
                    <h4 className="d-sm-block">
                        {t("calculator.ytongCalculator.AmountOfYtongBlockGlue")}
                    </h4>
                    <Row>
                        <ResultField
                            copy={t(
                                "calculator.ytongCalculator.AmountOfKgGlue"
                            )}
                            value={amountOfKgGlue().toFixed(2)}
                            sm={6}
                            unit={"kg"}
                        />
                        <ResultField
                            copy={t("calculator.nrBags25Kg")}
                            value={nrOf25KgBagsGlue().toFixed(0)}
                            sm={6}
                        />
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default Result;
